<template>
  <div style="max-width: 95%;" class="mx-auto mt-8">
    <v-btn
      :loading="loadingReturn"
      :to="`/kategoria/${returnSlug}`"
      dark
      class="blue-grey darken-3"
      >Palaa taakse</v-btn
    >
    <v-alert type="error" class="mt-4"
      >Huomaa: tämä näkymä on keskeneräinen ja tätä uudistetaan pian.
      Pahoittelut!</v-alert
    >
    <v-card class="my-8" outlined>
      <v-card-title>
        <div v-if="!loading">{{ company.businessName }}</div>
        <div v-else>
          <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        </div>
      </v-card-title>
      <v-card-text>
        <div v-if="!loading">
          <span v-html="htmlInfo"></span>
          <p class="mt-4 title">Aukioloajat:</p>
          <table>
            <tr v-for="(d, i) in daySchema" :key="i">
              <th>{{ d }}</th>
              <th>{{ company.openHours[i] }}</th>
            </tr>
          </table>
          <v-img
            v-if="company.filestackHandle !== 'ef7GrvYSdGRfEOAR3a0u'"
            :src="`https://cdn.filestackcontent.com/${this.company.filestackHandle}`"
            max-height="200"
            contain
          ></v-img>
          <p
            class="px-4 pt-4 overline font-italic font-weight-light"
            style="
              font-size: 5px;
              line-height: 100%;
              letter-spacing: 0 !important;
            "
          >
            Ylläolevat tekijänoikeuksin suojatut merkit omistaa niiden omistaja.
            Tietojen oikeudellisuudesta vastaa {{ company.businessName }}.
            Yritys on antanut kirjallisen luvan esittää yllä olevat tiedot tällä
            sivulla.
          </p>
        </div>
        <div v-else>
          <v-skeleton-loader
            ref="skeleton"
            type="paragraph"
          ></v-skeleton-loader>
        </div>
      </v-card-text>
    </v-card>
    <v-progress-circular
      v-if="loading"
      :size="80"
      :width="8"
      color="green"
      indeterminate
    />
  </div>
</template>

<script>
export default {
  name: 'Company',
  props: {
    companyid: String
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    fetch(
      `https://hallinta.kotona.kiuruvesi.net/fontend/company/${this.companyid}`
    )
      .then(res => res.json())
      .then(res => {
        return (this.company = { ...res })
      })
      .then(() => {
        return fetch(`https://hallinta.kotona.kiuruvesi.net/fontend/catInfo`)
          .then(res => res.json())
          .then(res => {
            let query = res.find(x => x.backend === this.company.category)
            if (query) {
              return (this.returnSlug = query.slug)
            } else {
              alert('Sivulla tapahtui virhe! :( (loadingCatI)')
              return {}
            }
          })
          .catch(
            e =>
              void alert(
                'Järjestelmävirhe! Sivua ei voi näyttää :( (sysComp) ' + e
              )
          )
          .finally(() => {
            this.loadingReturn = false
          })
      })
      .catch(
        e =>
          void alert('Järjestelmävirhe! Sivua ei voi näyttää :( (sysComp) ' + e)
      )
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    htmlInfo() {
      return this.company.infoText
        .replace(
          // eslint-disable-next-line no-useless-escape
          /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g,
          // eslint-disable-next-line no-console
          t => `<a target="_blank" href="${t}">${t}</a>`
        )
        .replace(/\n/g, '<br>')
    }
  },
  data: () => ({
    loading: true,
    loadingReturn: true,
    company: {
      businessName: 'Järjestelmävirhe',
      infoText: 'Järjestelmävirhe',
      filestackHandle: 'ef7GrvYSdGRfEOAR3a0u',
      category: 'food'
    },
    returnSlug: 'ruokaa',
    daySchema: ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su']
  })
}
</script>
